import { render, staticRenderFns } from "./horse.vue?vue&type=template&id=02cfb126&"
import script from "./horse.vue?vue&type=script&lang=js&"
export * from "./horse.vue?vue&type=script&lang=js&"
import style0 from "./horse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports